export const FormControlTestAttributes = {
    errorText: 'form-control-error-text',
    clearButton: 'form-control-clear',
    actionButton: 'form-control-action',
};
